(function () {
  'use strict';

  var root = document.getElementById('SiteLocationPrompt');
  if (!root) return;

  var panel = root.querySelector('.site-location-prompt__panel');
  var statusEl = root.querySelector('[data-location-status]');
  var useBtn = root.querySelector('[data-location-use]');
  var manualToggle = root.querySelector('[data-location-manual-toggle]');
  var manualPanel = root.querySelector('[data-location-manual]');
  var headerChips = Array.prototype.slice.call(document.querySelectorAll('[data-header-location-chip]'));
  var savedAddressButtons = Array.prototype.slice.call(root.querySelectorAll('[data-location-saved-address]'));
  var customerLoggedIn = root.dataset.customerLoggedIn === 'true';
  var mapsApiKey = root.dataset.googleMapsApiKey || '';
  var PREF_KEY = 'alasil:location-preference:v1';
  var SESSION_KEY = 'alasil:location:session';
  var CART_LOCATION_KEY = 'cartDeliveryLocation';
  var isOpen = false;
  var isLocating = false;
  var lockId = null;
  var returnFocus = null;
  var openTimer = null;
  var retryCount = 0;
  var mapsLoadPromise = null;
  var addressContext = null;
  var addressContextPromise = null;
  var locationRequest = 0;
  var inertElements = [];

  function isolateBackground() {
    var branch = root;
    while (branch.parentElement) {
      Array.prototype.forEach.call(branch.parentElement.children, function (element) {
        if (element === branch || element.inert) return;
        element.inert = true;
        inertElements.push(element);
      });
      branch = branch.parentElement;
      if (branch === document.body) break;
    }
  }

  function cancelLocationRequest() {
    locationRequest++;
    isLocating = false;
    if (useBtn) useBtn.disabled = false;
  }

  function readJson(storage, key) {
    try { return JSON.parse(storage.getItem(key) || 'null'); } catch (e) { return null; }
  }

  function writeJson(storage, key, value) {
    try { storage.setItem(key, JSON.stringify(value)); } catch (e) { /* storage unavailable */ }
  }

  function preference() { return readJson(localStorage, PREF_KEY) || {}; }

  function localizedEmirate(value) {
    var arabicToEnglish = {
      'دبي': 'Dubai',
      'أبوظبي': 'Abu Dhabi',
      'الشارقة': 'Sharjah',
      'عجمان': 'Ajman',
      'رأس الخيمة': 'Ras Al Khaimah',
      'الفجيرة': 'Fujairah',
      'أم القيوين': 'Umm Al Quwain'
    };
    var canonical = arabicToEnglish[value] || value;
    if (root.dataset.isAr !== 'true') return canonical;
    var labels = {
      'Dubai': 'دبي',
      'Abu Dhabi': 'أبوظبي',
      'Sharjah': 'الشارقة',
      'Ajman': 'عجمان',
      'Ras Al Khaimah': 'رأس الخيمة',
      'Fujairah': 'الفجيرة',
      'Umm Al Quwain': 'أم القيوين'
    };
    return labels[canonical] || value;
  }

  function storedHeaderLocation() {
    if (customerLoggedIn) {
      if (addressContext && addressContext.addresses && addressContext.addresses.length) {
        var selectedId = String(addressContext.selectedAddressId || addressContext.defaultAddressId || '');
        var selected = addressContext.addresses.find(function (address) { return String(address.id) === selectedId; }) || addressContext.addresses[0];
        var metadata = (addressContext.locations || {})[String(selected.id)] || {};
        return { label: metadata.label || selected.company || selected.city || selected.province || '', hasLocation: true };
      }
      var initial = headerChips[0] && headerChips[0].dataset.initialAddressLabel;
      if (initial) return { label: initial, hasLocation: true };
    }
    var pref = preference();
    var saved = readJson(localStorage, CART_LOCATION_KEY) || {};
    var currentLocale = root.dataset.isAr === 'true' ? 'ar' : 'en';
    var prefAt = Math.max(Number(pref.areaSelectedAt || 0), Number(pref.areaResolvedAt || 0));
    var savedAt = Number(saved.areaResolvedAt || 0);
    if (prefAt >= savedAt && (pref.headerLabel || pref.areaLabel || pref.area)) {
      var preferenceLabel = pref.headerLocale === currentLocale
        ? (pref.headerLabel || pref.areaLabel || localizedEmirate(pref.area))
        : localizedEmirate(pref.area);
      return { label: preferenceLabel, hasLocation: true };
    }
    var savedLabel = saved.area || saved.city || saved.emirate;
    if (savedLabel) return { label: localizedEmirate(savedLabel), hasLocation: true };
    var session = readJson(sessionStorage, SESSION_KEY);
    if (session && Number(session.expiresAt || 0) > Date.now()) {
      return { label: session.headerLabel || '', hasLocation: true };
    }
    return { label: '', hasLocation: false };
  }

  function renderHeaderLocation(override) {
    var state = override || storedHeaderLocation();
    headerChips.forEach(function (chip) {
      var label = chip.querySelector('[data-header-location-label]');
      var text = state.label || (state.hasLocation ? chip.dataset.currentLabel : chip.dataset.emptyLabel);
      if (label) label.textContent = text;
      chip.classList.toggle('has-location', !!state.hasLocation);
      chip.setAttribute('aria-label', (root.dataset.isAr === 'true' ? 'موقع التوصيل: ' : 'Delivery location: ') + text);
      chip.title = text;
    });
  }

  function loadAddressContext(force) {
    if (!customerLoggedIn) return Promise.resolve(null);
    if (addressContextPromise && !force) return addressContextPromise;
    addressContextPromise = fetch('/apps/avatar/address/context', { credentials: 'same-origin' })
      .then(function (response) { if (!response.ok) throw new Error('context'); return response.json(); })
      .then(function (context) {
        addressContext = context;
        window.alasilAddressContext = context;
        syncSavedAddressUi();
        renderHeaderLocation();
        document.dispatchEvent(new CustomEvent('alasil:address-context', { detail: context }));
        return context;
      })
      .catch(function () { return null; });
    return addressContextPromise;
  }

  function syncSavedAddressUi() {
    if (!addressContext) return;
    var selectedId = String(addressContext.selectedAddressId || addressContext.defaultAddressId || '');
    savedAddressButtons.forEach(function (button) {
      var id = String(button.dataset.addressId || '');
      var selected = id === selectedId;
      var metadata = (addressContext.locations || {})[id] || {};
      var title = button.querySelector('.site-location-prompt__address-copy strong');
      if (title && metadata.label) title.textContent = metadata.label;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
  }

  function cartLocationFromAddress(button) {
    var id = String(button.dataset.addressId || '');
    var metadata = addressContext && addressContext.locations ? addressContext.locations[id] || {} : {};
    var lat = Number(metadata.lat);
    var lng = Number(metadata.lng);
    var value = {
      customer_address_id: id,
      label: metadata.label || button.dataset.addressLabel || '',
      building: button.dataset.addressBuilding || '',
      unit: button.dataset.addressUnit || '',
      city: button.dataset.addressCity || '',
      area: button.dataset.addressArea || button.dataset.addressCity || '',
      emirate: button.dataset.addressEmirate || '',
      zip: button.dataset.addressZip || '',
      firstName: button.dataset.addressFirstName || '',
      lastName: button.dataset.addressLastName || '',
      phone: button.dataset.addressPhone || '',
      place_id: metadata.placeId || '',
      savedAt: Date.now(),
      areaResolvedAt: Date.now()
    };
    if (isFinite(lat) && isFinite(lng)) {
      value.lat = lat;
      value.lng = lng;
      value.maps_url = 'https://www.google.com/maps?q=' + lat + ',' + lng;
    }
    return value;
  }

  function selectSavedAddress(button) {
    if (!button || button.disabled) return;
    button.disabled = true;
    showStatus(root.dataset.isAr === 'true' ? 'جارٍ اختيار العنوان…' : 'Selecting address…', 'loading');
    fetch('/apps/avatar/address/select', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ addressId: button.dataset.addressId })
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (body) {
        if (!response.ok) throw new Error(body.detail || 'select');
        return body;
      });
    }).then(function (body) {
      if (addressContext) addressContext.selectedAddressId = String(body.selectedAddressId || button.dataset.addressId);
      writeJson(localStorage, CART_LOCATION_KEY, cartLocationFromAddress(button));
      syncSavedAddressUi();
      renderHeaderLocation();
      document.dispatchEvent(new CustomEvent('alasil:customer-address-selected', {
        detail: { addressId: String(button.dataset.addressId || ''), location: cartLocationFromAddress(button) }
      }));
      showStatus(root.dataset.isAr === 'true' ? 'تم اختيار عنوان التوصيل.' : 'Delivery address selected.', 'success');
      setTimeout(function () { close({ preserveStatus: false }); }, 650);
    }).catch(function () {
      showStatus(root.dataset.isAr === 'true' ? 'تعذر اختيار العنوان. حاول مرة أخرى.' : 'Could not select that address. Try again.', 'error');
    }).finally(function () { button.disabled = false; });
  }

  function updatePreference(patch) {
    var next = preference();
    Object.keys(patch).forEach(function (key) { next[key] = patch[key]; });
    writeJson(localStorage, PREF_KEY, next);
    return next;
  }

  function anotherOverlayIsOpen() {
    return !!document.querySelector(
      'cart-drawer.active, cart-drawer.is-open, #SearchSheet.is-open, '
      + '.account-drawer.is-open, [role="dialog"][aria-hidden="false"]:not(#SiteLocationPrompt)'
    );
  }

  function lockScroll() {
    if (lockId !== null || !window.themeSheetScrollLock) return;
    lockId = window.themeSheetScrollLock.lock(function () { return isOpen ? panel : null; });
  }

  function unlockScroll() {
    if (lockId === null || !window.themeSheetScrollLock) return;
    window.themeSheetScrollLock.unlock(lockId);
    lockId = null;
  }

  function focusable() {
    return Array.prototype.slice.call(panel.querySelectorAll('button:not([disabled]), [href], input, select, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return !el.hidden && el.offsetParent !== null; });
  }

  function showStatus(message, state) {
    root.dataset.state = state || '';
    statusEl.textContent = message || '';
    statusEl.hidden = !message;
  }

  function open(options) {
    options = options || {};
    if (isOpen) return;
    /* The full sheet stylesheet is interaction-loaded. Pointer/touch intent
       normally starts it before click; this call also covers keyboard opens,
       public API calls and the location_prompt=1 preview URL. Critical inline
       CSS keeps the sheet hidden until the stylesheet promise marks it ready. */
    if (typeof window.__loadLocationPromptStyles === 'function') {
      window.__loadLocationPromptStyles();
    }
    if (!options.force && anotherOverlayIsOpen()) {
      if (retryCount++ < 12) openTimer = setTimeout(function () {
        openTimer = null;
        open(options);
      }, 1000);
      return;
    }
    retryCount = 0;
    isOpen = true;
    returnFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    isolateBackground();
    lockScroll();
    var openedRequest = locationRequest;
    setTimeout(function () {
      if (isOpen && openedRequest === locationRequest && useBtn) useBtn.focus({ preventScroll: true });
    }, 80);
    document.dispatchEvent(new CustomEvent('alasil:location-prompt-opened'));
    if (customerLoggedIn) loadAddressContext();
  }

  function close(options) {
    options = options || {};
    if (!isOpen) return;
    isOpen = false;
    cancelLocationRequest();
    inertElements.forEach(function (element) { element.inert = false; });
    inertElements = [];
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    if (manualPanel) manualPanel.hidden = true;
    if (manualToggle) manualToggle.setAttribute('aria-expanded', 'false');
    if (!options.preserveStatus) showStatus('', '');
    unlockScroll();
    if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus({ preventScroll: true });
    returnFocus = null;
  }

  function dispatchLocation(position) {
    var detail = {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
      accuracy: position.coords.accuracy,
      capturedAt: Date.now()
    };
    writeJson(sessionStorage, SESSION_KEY, {
      lat: detail.latitude,
      lng: detail.longitude,
      accuracy: detail.accuracy,
      headerLabel: preference().headerLabel || '',
      emirate: preference().area || '',
      capturedAt: detail.capturedAt,
      expiresAt: Date.now() + 30 * 60 * 1000
    });
    document.dispatchEvent(new CustomEvent('alasil:location-detected', { detail: detail }));
  }

  function ensureGoogleMaps() {
    if (window.google && window.google.maps && window.google.maps.Geocoder) return Promise.resolve(true);
    if (mapsLoadPromise) return mapsLoadPromise;
    if (!mapsApiKey) return Promise.resolve(false);

    mapsLoadPromise = new Promise(function (resolve) {
      var existing = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
      var attempts = 0;
      function waitForMaps() {
        if (window.google && window.google.maps && window.google.maps.Geocoder) { resolve(true); return; }
        if (attempts++ >= 80) { resolve(false); return; }
        setTimeout(waitForMaps, 100);
      }
      if (existing) { waitForMaps(); return; }

      window.__alasilLocationMapsReady = function () { resolve(true); };
      var script = document.createElement('script');
      script.dataset.alasilLocationMaps = 'true';
      script.async = true;
      script.onerror = function () { resolve(false); };
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(mapsApiKey)
        + '&libraries=geometry&callback=__alasilLocationMapsReady&loading=async&v=weekly';
      document.head.appendChild(script);
    });
    return mapsLoadPromise;
  }

  function reverseGeocodeLocation(latitude, longitude, request, done) {
    var finished = false;
    var timer = setTimeout(function () { finish(false); }, 10000);
    function finish(success) {
      if (finished) return;
      finished = true;
      clearTimeout(timer);
      if (request === locationRequest) done(success);
    }
    ensureGoogleMaps().then(function (ready) {
      if (finished || request !== locationRequest) return;
      if (!ready || !window.google || !window.google.maps) { finish(false); return; }
      var geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({
        location: { lat: Number(latitude), lng: Number(longitude) },
        language: root.dataset.isAr === 'true' ? 'ar' : 'en',
        region: 'ae'
      }, function (results, status) {
        if (finished || request !== locationRequest) return;
        if (status !== 'OK' || !results || !results.length) { finish(false); return; }
        var components = results[0].address_components || [];
        var emirate = '';
        var locality = '';
        var area = '';
        components.forEach(function (component) {
          var types = component.types || [];
          if (!emirate && types.indexOf('administrative_area_level_1') !== -1) emirate = component.long_name || component.short_name;
          if (!locality && (types.indexOf('locality') !== -1 || types.indexOf('administrative_area_level_2') !== -1)) locality = component.long_name;
          if (!area && (types.indexOf('sublocality_level_1') !== -1 || types.indexOf('neighborhood') !== -1)) area = component.long_name;
        });
        var headerLabel = area || locality || emirate;
        if (!headerLabel) { finish(false); return; }
        var resolvedAt = Date.now();
        updatePreference({
          mode: 'device',
          area: emirate || locality,
          areaLabel: locality || emirate,
          headerLabel: headerLabel,
          headerLocale: root.dataset.isAr === 'true' ? 'ar' : 'en',
          areaResolvedAt: resolvedAt
        });
        var session = readJson(sessionStorage, SESSION_KEY) || {};
        session.headerLabel = headerLabel;
        session.emirate = emirate || locality;
        writeJson(sessionStorage, SESSION_KEY, session);
        renderHeaderLocation({ label: headerLabel, hasLocation: true });
        document.dispatchEvent(new CustomEvent('alasil:delivery-area-changed', {
          detail: { area: emirate || locality, label: headerLabel, source: 'device' }
        }));
        finish(true);
      });
    }).catch(function () { finish(false); });
  }

  function locate(options) {
    options = options || {};
    if (isLocating) return;
    if (!navigator.geolocation) {
      if (!isOpen) open({ force: true });
      showStatus(root.dataset.statusUnavailable, 'error');
      return;
    }

    isLocating = true;
    var request = ++locationRequest;
    if (useBtn) useBtn.disabled = true;
    if (isOpen) showStatus(root.dataset.statusLoading, 'loading');

    navigator.geolocation.getCurrentPosition(function (position) {
      if (request !== locationRequest) return;
      reverseGeocodeLocation(position.coords.latitude, position.coords.longitude, request, function (success) {
      isLocating = false;
      if (useBtn) useBtn.disabled = false;
      if (!success) {
        if (isOpen) {
          showStatus(root.dataset.statusUnavailable, 'error');
          if (manualPanel) manualPanel.hidden = false;
          if (manualToggle) manualToggle.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      dispatchLocation(position);
      updatePreference({
        mode: 'device',
        lastGrantedAt: Date.now()
      });
      if (isOpen) {
        showStatus(root.dataset.statusSuccess, 'success');
        setTimeout(function () { if (request === locationRequest) close({ preserveStatus: false }); }, 950);
      }
      });
    }, function (error) {
      if (request !== locationRequest) return;
      isLocating = false;
      if (useBtn) useBtn.disabled = false;
      if (options.silent) return;
      if (!isOpen) open({ force: true });
      if (error && error.code === 1) {
        updatePreference({ mode: 'denied', lastDeniedAt: Date.now() });
        showStatus(root.dataset.statusDenied, 'error');
      } else if (error && error.code === 3) {
        showStatus(root.dataset.statusTimeout, 'error');
      } else {
        showStatus(root.dataset.statusUnavailable, 'error');
      }
    }, {
      enableHighAccuracy: false,
      timeout: 8000,
      maximumAge: 300000
    });
  }

  function selectArea(area, label) {
    cancelLocationRequest();
    var request = locationRequest;
    try { sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
    var displayArea = label || area;
    updatePreference({
      mode: 'manual',
      area: area,
      areaLabel: label || area,
      headerLabel: label || area,
      headerLocale: root.dataset.isAr === 'true' ? 'ar' : 'en',
      areaSelectedAt: Date.now()
    });
    document.dispatchEvent(new CustomEvent('alasil:delivery-area-changed', { detail: { area: area, source: 'manual' } }));
    renderHeaderLocation({ label: displayArea, hasLocation: true });
    var message = root.dataset.isAr === 'true' ? 'تم اختيار ' + displayArea : 'Delivery area set to ' + displayArea + '.';
    showStatus(message, 'success');
    setTimeout(function () {
      if (request === locationRequest) close({ preserveStatus: false });
    }, 800);
  }

  function openPreviewIfRequested() {
    var forcePreview = false;
    try { forcePreview = new URLSearchParams(window.location.search).get('location_prompt') === '1'; } catch (e) {}
    if (!forcePreview) return;
    openTimer = setTimeout(function () {
      openTimer = null;
      open({ force: true });
    }, 250);
  }

  root.querySelectorAll('[data-location-dismiss]').forEach(function (button) {
    button.addEventListener('click', function () { close(); });
  });

  headerChips.forEach(function (chip) {
    chip.addEventListener('click', function () { open({ force: true }); });
  });

  savedAddressButtons.forEach(function (button) {
    button.addEventListener('click', function () { selectSavedAddress(button); });
  });
  var addAddressButton = root.querySelector('[data-location-add-address]');
  if (addAddressButton) addAddressButton.addEventListener('click', function () {
    close({ preserveStatus: false });
    setTimeout(function () {
      if (typeof window.openAccountDrawerScreen === 'function') window.openAccountDrawerScreen('addressForm');
      else if (typeof window.openAccountDrawer === 'function') window.openAccountDrawer();
    }, 80);
  });
  var manageAddressesButton = root.querySelector('[data-location-manage-addresses]');
  if (manageAddressesButton) manageAddressesButton.addEventListener('click', function () {
    close({ preserveStatus: false });
    setTimeout(function () {
      if (typeof window.openAccountDrawerScreen === 'function') window.openAccountDrawerScreen('addresses');
      else if (typeof window.openAccountDrawer === 'function') window.openAccountDrawer();
    }, 80);
  });

  if (useBtn) useBtn.addEventListener('click', function () { locate(); });
  if (manualToggle) manualToggle.addEventListener('click', function () {
    manualPanel.hidden = !manualPanel.hidden;
    manualToggle.setAttribute('aria-expanded', manualPanel.hidden ? 'false' : 'true');
    if (!manualPanel.hidden) {
      var firstArea = manualPanel.querySelector('[data-location-area]');
      if (firstArea) firstArea.focus();
    }
  });
  root.querySelectorAll('[data-location-area]').forEach(function (button) {
    button.addEventListener('click', function () { selectArea(button.dataset.locationArea, button.textContent.trim()); });
  });

  root.addEventListener('keydown', function (event) {
    if (!isOpen) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    var items = focusable();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('alasil:delivery-area-changed', function () { renderHeaderLocation(); });

  window.alasilLocation = {
    open: function () { open({ force: true }); },
    close: close,
    request: locate,
    getPreference: preference,
    getSessionLocation: function () { return readJson(sessionStorage, SESSION_KEY); },
    refreshHeader: renderHeaderLocation,
    clear: function () {
      try { localStorage.removeItem(PREF_KEY); sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
    }
  };

  renderHeaderLocation();
  if (customerLoggedIn) loadAddressContext();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openPreviewIfRequested, { once: true });
  else openPreviewIfRequested();
})();
